import { render, staticRenderFns } from "./VideoShow.vue?vue&type=template&id=28642bc5&scoped=true&"
import script from "./VideoShow.vue?vue&type=script&lang=js&"
export * from "./VideoShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28642bc5",
  null
  
)

export default component.exports